import queryString from 'query-string'

// window.asset_hostによるURL組み立ては webpack publicPath: 'auto' で代替されたため除去
// 今後は使用しない方針で対応するため、buildAssetUrlString は path をそのまま返すだけにする
export const buildAssetUrlString = (path) => {
  return queryString.stringifyUrl({ url: path })
}
